import { useAuthUserQuery, useSubscriptionStatusQuery } from "@/hooks";
import TrialFormatPriceSVOD from "./TrialFormatPriceSVOD";
import NonTrialFormatPriceSVOD from "./NonTrialFormatPriceSVOD";
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormatPriceSVOD(_ref) {
  var price = _ref.price,
      ext = _ref.ext,
      course = _ref.course;

  var _useSubscriptionStatu = useSubscriptionStatusQuery({
    variables: {
      courseId: Number(course === null || course === void 0 ? void 0 : course.id)
    }
  }),
      data = _useSubscriptionStatu.data,
      loadingSubscriptionStatus = _useSubscriptionStatu.loading;

  var _useAuthUserQuery = useAuthUserQuery(),
      user = _useAuthUserQuery.data,
      loadingUser = _useAuthUserQuery.loading;

  if (loadingUser && loadingSubscriptionStatus) return null;
  var loggedIn = !loadingUser && (user === null || user === void 0 ? void 0 : user.user);
  var isTrialEnabled = loggedIn ? data === null || data === void 0 ? void 0 : data.subscriptionStatus.is_trial_enabled : true;

  if (course !== null && course !== void 0 && course.trial_flag && isTrialEnabled) {
    return /*#__PURE__*/_jsx(TrialFormatPriceSVOD, {
      price: price,
      ext: ext,
      course: course
    });
  } else {
    return /*#__PURE__*/_jsx(NonTrialFormatPriceSVOD, {
      price: price,
      ext: ext
    });
  }
}